import axios from "axios";
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL;

class FJenisDocService {
  getApiUrl() {
    return API_URL;
  }
  getAllFJenisDoc() {
    return axios.get(API_URL + `getAllFJenisDoc`, {
      headers: authHeader(),
    });
  }
  getAllFJenisDocByDivision(fdivisionBean) {
    return axios.get(API_URL + `getAllFJenisDocByDivision/${fdivisionBean}`, {
      headers: authHeader(),
    });
  }
  getAllFJenisDocPublic() {
    return axios.get(API_URL + `public/getAllFJenisDoc`, {
      headers: authHeader(),
    });
  }
  getAllFJenisDocContaining(page, pageSize, sortBy, order, search) {
    return axios.get(
        API_URL +
        `getAllFJenisDocContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
        { headers: authHeader() }
    );
  }
  getFJenisDocById(id) {
    return axios.get(API_URL + `getFJenisDocById/${id}`, {
      headers: authHeader(),
    });
  }
  updateFJenisDoc(item) {
    return axios.put(API_URL + `updateFJenisDoc/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFJenisDoc(item) {
    return axios.post(API_URL + `createFJenisDoc`, item, {
      headers: authHeader(),
    });
  }
  deleteFJenisDoc(id) {
    return axios.delete(API_URL + `deleteFJenisDoc/${id}`, {
      headers: authHeader(),
    });
  }
  deleteAllFJenisDoc(itemIds) {
    // let user = JSON.parse(localStorage.getItem('user'));
    // return axios.delete(API_URL + `deleteAllFJenisDoc`, {
    //     headers:  authHeaderMultipart(),
    //     data: {
    //         message: 'delete  success'
    //     }
    // });
    return axios.delete(API_URL + `deleteAllFJenisDoc`, {
      headers: authHeader(),
      data: itemIds,
    });
  }

  getAllFJenisDocContainingPublic(page, pageSize, sortBy, order, search) {
    return axios.get(
        API_URL +
        `public/getAllFJenisDocContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
        { headers: authHeader() }
    );
  }

}
export default new FJenisDocService();
